var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpandsupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 3.0376H8.75C5 3.0376 2.5 5.5376 2.5 9.2876V16.7876C2.5 20.5376 5 23.0376 8.75 23.0376V25.7001C8.75 26.7001 9.8625 27.3001 10.6875 26.7376L16.25 23.0376H21.25C25 23.0376 27.5 20.5376 27.5 16.7876V9.2876C27.5 5.5376 25 3.0376 21.25 3.0376ZM15 18.2501C14.475 18.2501 14.0625 17.8251 14.0625 17.3126C14.0625 16.8001 14.475 16.3751 15 16.3751C15.525 16.3751 15.9375 16.8001 15.9375 17.3126C15.9375 17.8251 15.525 18.2501 15 18.2501ZM16.575 13.0626C16.0875 13.3876 15.9375 13.6001 15.9375 13.9501V14.2126C15.9375 14.7251 15.5125 15.1501 15 15.1501C14.4875 15.1501 14.0625 14.7251 14.0625 14.2126V13.9501C14.0625 12.5001 15.125 11.7876 15.525 11.5126C15.9875 11.2001 16.1375 10.9876 16.1375 10.6626C16.1375 10.0376 15.625 9.5251 15 9.5251C14.375 9.5251 13.8625 10.0376 13.8625 10.6626C13.8625 11.1751 13.4375 11.6001 12.925 11.6001C12.4125 11.6001 11.9875 11.1751 11.9875 10.6626C11.9875 9.0001 13.3375 7.6501 15 7.6501C16.6625 7.6501 18.0125 9.0001 18.0125 10.6626C18.0125 12.0876 16.9625 12.8001 16.575 13.0626Z",
    fill: "#161F28"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpandsupport);
export default __webpack_public_path__ + "static/media/helpandsupport.652980c04bcea301955dac9e1be44152.svg";
export { ForwardRef as ReactComponent };